import React from 'react'

const RegisterUserScreen = () => {
  return (
    <div>
      <h4>Register User Screen</h4>
    </div>
  )
}

export default RegisterUserScreen
